import CellFormatter from "../../../component/cell-formatter";

export const columnsDSCdhaTdcn = [
	{
		title: 'Tên dịch vụ',
		field: 'name',
		className: 'spaces width-40',
		render: (rowData: any) => <CellFormatter rowData={rowData} value={rowData.name} />,
	},
	{
		title: 'SL',
		field: 'quantity',
		className: 'spaces width-10 text-center',
		render: (rowData: any) => (
			<CellFormatter rowData={rowData} value={rowData.isCancel ? 0 : 1} />
		),
	},
	{
		title: 'Kết quả',
		field: 'ketQua',
		className: 'spaces width-20',
		render: (rowData: any) => <CellFormatter rowData={rowData} value={rowData?.obs?.value} />,
	},
	{
		title: 'Loại bệnh phẩm',
		field: 'type',
		className: 'spaces width-15',
	},
	{
		title: 'Đối tượng',
		field: 'doiTuong',
		className: 'spaces width-15',
		render: (rowData: any) => <CellFormatter rowData={rowData} value={rowData?.objectTypeName} />,
	},
];
